export const SET_ESTIMATE_TEMPLATES = 'SET_ESTIMATE_TEMPLATES'
